import { motion, useReducedMotion } from "motion/react";
import type { ComponentPropsWithoutRef } from "react";

import { EASE_OUT_STRONG } from "./constants";

interface AnimatedContainerProps
  extends ComponentPropsWithoutRef<typeof motion.div> {
  /** Delay between each child animation. Default: 0.06s */
  staggerDelay?: number;
  /** Delay before first child starts. Default: 0 */
  delayChildren?: number;
}

/**
 * Stagger parent that orchestrates children using Framer Motion variant propagation.
 * Children should use AnimatedCard or AnimatedItem — they animate in sequence
 * without needing their own initial/animate props.
 */
export function AnimatedContainer({
  staggerDelay = 0.06,
  delayChildren = 0,
  ...props
}: AnimatedContainerProps) {
  const shouldReduceMotion = useReducedMotion();

  const variants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: shouldReduceMotion ? 0 : staggerDelay,
        delayChildren,
        ease: EASE_OUT_STRONG,
      },
    },
  };

  return (
    <motion.div
      variants={variants}
      initial="hidden"
      animate="visible"
      {...props}
    />
  );
}
